import styled, {keyframes} from 'styled-components'
import syncIco from './sync-alt-solid.svg'
import theme from '../../../../styles/style';

export const Fail = styled.p`
    padding:1em;
    //margin: 3em 0 0 0;
    border:  ${theme.danger} 5px dotted;
    text-align: center;
    color: ${theme.textColor};
`
export const Success = styled.p`
    padding:1em;
    //margin: 0em 0 0 0;
    border:  ${theme.success} 5px dotted;
    text-align: center;
    color: ${theme.textColor};
`
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
export const Spinner = styled.span`
  content: url(${syncIco});
  //margin-left:0.2em;
  height:0.8em;
  animation: ${rotate} 1s ease infinite;
`

export const Form = styled.form`
    width: 100%;
    margin-bottom: 3rem;
    color: ${theme.primaryColor};
    display: flex;
    flex-direction: column;
    input, textarea {
        background-color: transparent;
        padding: 0.5em 0 0.5em 1em;
        margin: 1em 0;
        border: none;
        color:  ${theme.primary};
        border-bottom: solid 1px ${theme.white};
    }
    input[type='checkbox']{
      background-color: ${theme.textColor};
      width:1.5em;
    }
    input:focus-visible, textarea:focus-visible {
      outline: 1px solid ${theme.thirdColor};
      border-bottom: none;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      outline: 1px solid ${theme.thirdColor};
      -webkit-text-fill-color: ${theme.thirdColor};
      transition: background-color 5000s ease-in-out 0s;
    }
`
export const Private = styled.div`
  display:flex;
  color:white;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: baseline;
  label {
    font-size: 1rem;
    margin: 0 0 1.5em 0.2em;
    display: inline;
    color:${theme.white};
    @media (max-width:450px){
    font-size: 0.8rem;
  }
  }
  
` 
export const Button = styled.button`
cursor: pointer;
width:8em;
color: ${theme.backgroundLightColor} ;
align-items: center;
  padding: 0.7rem 1.2rem;
  border: none;
  border-radius: 30px;
  -webkit-appearance: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: ${theme.light};
  background: ${theme.orange};
  font-size: 1.2rem;
  position: relative;
  border: 2px transparent solid;
  transition: 1s;
  text-transform:uppercase;
  &:hover{
    
    background: ${theme.blue};
  }

  &:focus {
    border: 2px solid white;
  }

  &:disabled {
    background: gray;
  }
  ${({ secondary }) =>
    secondary &&
    `
		background: #001F3F;
	`}
`